import React, { useRef, useEffect, useState } from 'react';

import './index.scss';
import direction from '../../../assets/img/views/single/direction.png';
import { isNullObject } from '../../../utils';
interface enbaleStyle {
  conBgSide: number; // 底部圆圈背景的宽高
  carWidth: number; // 小车宽高
  carHeight: number;
  obstacleWidth: number; // 正常/障碍 图片的宽高
  obstacleHeight: number;
}
interface props {
  disabled: boolean;
  enable: any;
  enbaleLayout: enbaleStyle;
}
const benchmark = 2200;
const Enable = (props: props) => {
  const { disabled, enable, enbaleLayout } = props;
  const [enbaleStyle, setEnbaleStyle] = useState<enbaleStyle>(enbaleLayout);
  useEffect(() => {
    resize();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);
  const resize = () => {
    // 已1920为基础,等比缩放
    const bgSide =
      (document.body.clientWidth * enbaleLayout.conBgSide) / benchmark;
    const carW =
      (document.body.clientWidth * enbaleLayout.carWidth) / benchmark;
    const carH =
      (document.body.clientWidth * enbaleLayout.carHeight) / benchmark;
    const obstacleW =
      (document.body.clientWidth * enbaleLayout.obstacleWidth) / benchmark;
    const obstacleH =
      (document.body.clientWidth * enbaleLayout.obstacleHeight) / benchmark;
    setEnbaleStyle({
      ...enbaleStyle,
      conBgSide: bgSide,
      carWidth: carW,
      carHeight: carH,
      obstacleWidth: obstacleW,
      obstacleHeight: obstacleH,
    });
  };
  // 是否存在障碍
  const isObstacle = (value: any) => {
    if (typeof value == 'boolean' && !value) {
      return true;
    }
    false;
  };
  return (
    <div className='fbox vbox'>
      <div
        className='fbox vbox cbox  enable-con'
        style={{
          width: `${enbaleStyle.conBgSide}px`,
          height: `${enbaleStyle.conBgSide}px`,
        }}
      >
        <div className='direction'>
          <img src={direction}></img>
          <span>前</span>
        </div>
        <div
          className='car'
          style={{
            width: `${enbaleStyle.carWidth}px`,
            height: `${enbaleStyle.carHeight}px`,
          }}
        ></div>
        {!disabled && enable && (
          <>
            <div
              className={`top  ${isObstacle(enable.enableFront) ? 'top-warn' : ''}`}
              style={{
                width: `${enbaleStyle.obstacleWidth}px`,
                height: `${enbaleStyle.obstacleHeight}px`,
                marginLeft: `-${enbaleStyle.obstacleWidth / 2}px`,
              }}
            ></div>
            <div
              className={`right  ${isObstacle(enable.enableRight) ? 'right-warn' : ''}`}
              style={{
                width: `${enbaleStyle.obstacleHeight}px`,
                height: `${enbaleStyle.obstacleWidth}px`,
                marginTop: `-${enbaleStyle.obstacleWidth / 2}px`,
              }}
            ></div>
            <div
              className={`down  ${isObstacle(enable.enableBack) ? 'down-warn' : ''}`}
              style={{
                width: `${enbaleStyle.obstacleWidth}px`,
                height: `${enbaleStyle.obstacleHeight}px`,
                marginLeft: `-${enbaleStyle.obstacleWidth / 2}px`,
              }}
            ></div>
            <div
              className={`left  ${isObstacle(enable.enableLeft) ? 'left-warn' : ''}`}
              style={{
                width: `${enbaleStyle.obstacleHeight}px`,
                height: `${enbaleStyle.obstacleWidth}px`,
                marginTop: `-${enbaleStyle.obstacleWidth / 2}px`,
              }}
            ></div>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(Enable);
